module.exports = __webpack_public_path__ + "static/img/iso2.09c8e20e.png";